import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Search, MapPin, Mail } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { employees } from '../data';
const departments = ['All', ...Array.from(new Set(employees.map(e => e.department)))];
export function PeoplePage() {
  const [query, setQuery] = useState('');
  const [dept, setDept] = useState('All');
  const filtered = employees.filter(e => {
    const matchesQuery = e.name.toLowerCase().includes(query.toLowerCase()) || e.title.toLowerCase().includes(query.toLowerCase());
    const matchesDept = dept === 'All' || e.department === dept;
    return matchesQuery && matchesDept;
  });
  return <>
      <PageHeader title="People" subtitle={`${employees.length} team members across Independence Home Loans.`} data-id="element-564" data-mp="2sds4guoen54t" />

      <div className="flex flex-col sm:flex-row gap-3 mb-6" data-id="element-565" data-mp="31ezwiv0bv9qg">
        <div className="relative flex-1 max-w-md" data-id="element-566" data-mp="31fj8zw77l5x3">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-navy-400" data-id="element-567" data-mp="3b0twk2fry1ic" />
          <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search by name or title…" className="w-full pl-11 pr-4 py-2.5 rounded-full bg-white border border-navy-100 focus:border-gold-400 focus:outline-none focus:ring-2 focus:ring-gold-400/30 text-sm text-navy-900" data-id="element-568" data-mp="36ygp99ldpvjg" />
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-569" data-mp="3uqdqy7v4776u">
          {departments.map(d => <button key={d} onClick={() => setDept(d)} className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${dept === d ? 'bg-navy-600 text-white' : 'bg-white text-navy-600 border border-navy-100 hover:border-gold-400'}`} data-id="element-570" data-mp="3prkorbla32lz">
              {d}
            </button>)}
        </div>
      </div>

      {filtered.length === 0 ? <div className="text-center py-16 text-navy-400" data-id="element-571" data-mp="26qs5j74os2pe">
          No team members match your search.
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-572" data-mp="2asn5a76yy812">
          {filtered.map((e, i) => <motion.div key={e.id} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.03
      }} data-id="element-573" data-mp="1x0h01g5ctlge" data-mpi={i}>
              <Link to={`/people/${e.id}`} className="block bg-white rounded-xl border border-navy-100 p-5 text-center hover:shadow-md hover:border-gold-400 transition-all group" data-id="element-574" data-mp="1rzj9af6a3j3a">
                <img src={e.avatar} alt={e.name} className="w-20 h-20 rounded-full object-cover mx-auto mb-3 ring-2 ring-navy-50 group-hover:ring-gold-200 transition-all" data-id="element-575" data-mp="38fm68u4p224r" />
                <p className="font-bold text-navy-900" data-id="element-576" data-mp="3njovtmysmhcm">{e.name}</p>
                <p className="text-sm text-navy-500 mb-2" data-id="element-577" data-mp="3ikvj3wrbyudi">{e.title}</p>
                <span className="inline-block text-[0.7rem] font-semibold uppercase tracking-wide text-navy-600 bg-navy-50 px-2 py-1 rounded-full" data-id="element-578" data-mp="6342s5y73n6">
                  {e.department}
                </span>
                <div className="flex items-center justify-center gap-1 text-xs text-navy-400 mt-3" data-id="element-579" data-mp="a40pz90c4ocm">
                  <MapPin className="w-3 h-3" data-id="element-580" data-mp="55g0a3ipln2f" />
                  {e.location}
                </div>
              </Link>
            </motion.div>)}
        </div>}
    </>;
}